<template>
  <!-- mainlevel item without SubPage -->
  <div class="navdiv" v-if="menu.SubPage.length === 0 && getYesNo(menu, 'ShowHeadMenu')">
    <template v-if="!hasVisibleChildren">
      <v-tab 
          v-if="depth==1"
          :to="{ path: $methods.localePath(`${basePath}${menu.NameUrl}`) }" 
          class="text-none text-decoration-none navtabs justify-start">
        <v-list-item class="px-0 w-100" style="text-transform: none;">
          {{ menu.NameMenu }}
        </v-list-item>
      </v-tab>

      <NuxtLink 
        v-if="depth>1"
        class="text-left text-decoration-none navbaritemstext navrow"
        :to="{ path: $methods.localePath(`${basePath}${menu.NameUrl}`) }">
        <v-tab :width="widthTab" class="text-none text-decoration-none justify-start">
          <v-list-item class="px-0 w-100" style="text-transform: none;">
            {{ menu.NameMenu }}
          </v-list-item>
        </v-tab>
      </NuxtLink>
    </template>
  </div>

  <!-- mainlevel item with SubPage -->
  <div v-else-if="menu.SubPage.length > 0 && menu.NameMenu&& getYesNo(menu, 'ShowHeadMenu')">
    <v-menu open-on-hover :location="menuLocation" :offset="menuOffset" :close-on-content-click="false" :elevation="0" rounded="0"
      >
      <template v-slot:activator="{ props }">

      <v-tab 
          :width="widthTab" 
          v-bind="props" 
          :to="{ path: $methods.localePath(`${basePath}${menu.NameUrl}`) }"
          class="text-none text-decoration-none  justify-start position-relative">
          <v-list-item :width="widthTab" class="px-0 w-100 justify-start" style="text-transform: none;;text-align: left;">
            <span :class="['text-wrap', 'text-start', colorLink1PlusDepth]" style="max-width: 250px; word-break: break-word;">
              {{ menu.NameMenu }}
            </span>
          </v-list-item>
          <v-icon v-if="depth > 1 && hasVisibleChildren" icon="mdi-chevron-right" class="position-absolute" style="right: 8px; top: 50%; transform: translateY(-50%);" />
        </v-tab>
      </template>
      <v-list width="305px" v-if="hasVisibleChildren" elevation="0" class="pa-0 rounded-0 navbaritems" density="compact">
        <!-- Recursieve call for SubPage -->
        <v-list-item v-for="(child, idx) in visibleChildren" class="px-0 w-100">
          <MenuItemNavbar :depth="Number(depth) + 1" :menu="child" :basePath="`${basePath}${menu.NameUrl}/`" />
        </v-list-item>

      </v-list>
    </v-menu>
  </div>
  <div v-else>

  </div>
</template>

<script setup>
import { useNuxtApp } from '#app';
const { $methods } = useNuxtApp()
// Props
const props = defineProps({
  menu: {
    type: Object,
    required: true,
  },
  basePath: {
    type: String,
    required: true,
  },
  depth: {
    type: Number,
    required: true
  }
});


const hasVisibleChildren = computed(
  () => Array.isArray(props.menu.SubPage) && props.menu.SubPage.some(i => getYesNo(i, 'ShowHeadMenu') && i.NameMenu)
)

const visibleChildren = computed(
  () => (Array.isArray(props.menu.SubPage) ? props.menu.SubPage : []).filter(i =>  getYesNo(i, 'ShowHeadMenu')&& i.NameMenu)
)

const isRoot = computed(() => props.basePath === '/')
const menuLocation = computed(() => (isRoot.value ? 'bottom' : 'end'))
const menuOffset = computed(() => (isRoot.value ? [0, 0] : [0, 0]))
const widthTab =  computed(() => (props.depth >1? "300px" : "auto"))
const colorLink1PlusDepth=  computed(() => (props.depth >1? "text-primary" : ""))
const navtabs=  computed(() => (props.depth ==1? "navtabs" : ""))
</script>
<style scoped>
/* .navtabs {
  padding-left: 0 !important;
  padding-right: 0 !important;
} */

/* Als het nog steeds niet werkt: */

</style>
<style scoped>
/* Textlink-stijl in items */
.navbaritemstext {
  display: block;
  color: #1c1b1f;
  text-decoration: none;
}
/* Compacte dropdown menu styling */
.navbaritems.v-list {
  padding: 0 !important;
  margin: 0 !important;
}

.navbaritems .v-list-item {
  min-height: 32px !important;
  height: 32px !important;
  padding: 2px 0 !important;
  margin: 0 !important;
}

.navbaritems .v-list-item__content {
  padding: 0 !important;
}

.navbaritems .v-list-item__prepend,
.navbaritems .v-list-item__append {
  margin: 0 !important;
  padding: 0 !important;
}
/* V-tab rondingen wegwerken */
.v-tab {
  border-radius: 0 !important;
}

.v-tab:hover {
  border-radius: 0 !important;
}

.v-tab.v-tab--selected {
  border-radius: 0 !important;
}

/* Voor de hele tab container */
.v-tabs .v-tab {
  border-radius: 0 !important;
}
</style>